import { CommonEnums } from '../../common.enums';
import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Conn_Db_Obj_LnksUtil } from 'src/app/shared/utils/conn_db_obj_lnks.util';
import { DxFlow_Obj_PropertiesUtil } from 'src/app/shared/utils/dxflow_obj_properties.util';
import { Obj_Db_PropertyUtil } from 'src/app/shared/utils/obj_db_property.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { KafkaConsumer_Inst } from './kafkaconsumer_inst';

export class KafkaConsumer {
    kafkaConsumer_Inst: KafkaConsumer_Inst;
    conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: string;
    column_Properties: Array<Obj_Db_Property>;
    kafka_Consumer_Properties: Array<Obj_Db_Property>;
    target_Properties: Array<Obj_Db_Property>;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.kafkaConsumer_Inst = new KafkaConsumer_Inst();
        this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.change_Ind =  CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.STRING_EMPTY;
        this.column_Properties = new Array<Obj_Db_Property>();
        this.kafka_Consumer_Properties = new Array<Obj_Db_Property>();
        this.target_Properties = new Array<Obj_Db_Property>();
    }

    static parse(kafkaConsumerTmp: KafkaConsumer): KafkaConsumer {
        let kafkaConsumer: KafkaConsumer = new KafkaConsumer();
        kafkaConsumer.copyFrom(kafkaConsumerTmp);
        return kafkaConsumer;
    }

    copy(): KafkaConsumer {
        let kafkaConsumerTmp: KafkaConsumer = new KafkaConsumer();

        kafkaConsumerTmp.kafkaConsumer_Inst = this.kafkaConsumer_Inst.copy();
        kafkaConsumerTmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(this.conn_Db_Obj_Lnks);
        kafkaConsumerTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        kafkaConsumerTmp.change_Ind = this.change_Ind;
        kafkaConsumerTmp.error_Cd = this.error_Cd;
        kafkaConsumerTmp.error_Msg = this.error_Msg;
        kafkaConsumerTmp.ref_Id = this.ref_Id;
        kafkaConsumerTmp.ref_Cd = this.ref_Cd;
        kafkaConsumerTmp.fldr_Id = this.fldr_Id;
        kafkaConsumerTmp.column_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.column_Properties);
        kafkaConsumerTmp.kafka_Consumer_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.kafka_Consumer_Properties);
        kafkaConsumerTmp.target_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.target_Properties);
        return kafkaConsumerTmp;
    }

    copyFrom(KafkaConsumerTmp: KafkaConsumer): void {
        this.kafkaConsumer_Inst.copyFrom(KafkaConsumerTmp.kafkaConsumer_Inst);
        Conn_Db_Obj_LnksUtil.getInstance().copyFrom(this.conn_Db_Obj_Lnks, KafkaConsumerTmp.conn_Db_Obj_Lnks);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, KafkaConsumerTmp.dxFlow_Obj_Properties);
        this.change_Ind = KafkaConsumerTmp.change_Ind;
        this.error_Cd = KafkaConsumerTmp.error_Cd;
        this.error_Msg = KafkaConsumerTmp.error_Msg;
        this.ref_Id = KafkaConsumerTmp.ref_Id;
        this.ref_Cd= KafkaConsumerTmp.ref_Cd;
        this.fldr_Id = KafkaConsumerTmp.fldr_Id;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.column_Properties, KafkaConsumerTmp.column_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.kafka_Consumer_Properties, KafkaConsumerTmp.kafka_Consumer_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.target_Properties, KafkaConsumerTmp.target_Properties);

    }

    compare(KafkaConsumerTmp: KafkaConsumer): string {
        let diffString = '';
        diffString = (this.kafkaConsumer_Inst).compare(KafkaConsumerTmp.kafkaConsumer_Inst);
        if (diffString != '') return diffString;

        diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(this.conn_Db_Obj_Lnks, KafkaConsumerTmp.conn_Db_Obj_Lnks);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.kafka_Consumer_Properties, KafkaConsumerTmp.kafka_Consumer_Properties);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.column_Properties, KafkaConsumerTmp.column_Properties);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.target_Properties, KafkaConsumerTmp.target_Properties);
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(): string {
        return "KafkaConsumer [kafkaConsumer_Inst=" + this.kafkaConsumer_Inst +
            ", conn_Db_Obj_Lnks=" + Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd +
            ", fldr_Id=" + this.fldr_Id +
            ", column_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.column_Properties) +
            ", kafka_Consumer_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.kafka_Consumer_Properties) +
            ", target_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.target_Properties) + "]"
    }
}